<section class="sps-listen">

  <!-- KOPF -->
  <header class="kopf">
    <button mat-icon-button type="button" (click)="zurueckZumProjekt()" matTooltip="Zurück zum Projekt">
      <mat-icon>arrow_back</mat-icon>
    </button>

    <div class="kopf-titel">
      <h1>SPS-Listen</h1>
      <app-sps-breadcrumbs [teile]="[
        { text: 'Projekte', route: ['/projekte'], icon: 'folder' },
        { text: projektNummer ? projektNummer + ' · ' + projektName : (projektName || 'Projekt'), route: ['/projekte', projektId] },
        { text: 'SPS-Listen' }
      ]"></app-sps-breadcrumbs>
    </div>

    <div class="kopf-aktionen">
      <button mat-stroked-button type="button" (click)="laden()" [disabled]="laedt">
        <mat-icon>refresh</mat-icon>
        Aktualisieren
      </button>

      <button mat-stroked-button color="primary" type="button" (click)="zurSpsPruefung()" [disabled]="fortschritt.gesamt === 0"
        matTooltip="Gemeinsame Prüfung aller SPS-Signale des Projekts">
        <mat-icon>fact_check</mat-icon>
        SPS-Prüfung
      </button>

      <button mat-raised-button color="primary" type="button" *ngIf="canEdit" (click)="zumImport()">
        <mat-icon>add</mat-icon>
        Listen importieren
      </button>
    </div>
  </header>

  <!-- FEHLER -->
  <div class="fehlermeldung" *ngIf="fehler">
    <mat-icon>error_outline</mat-icon>
    <span>{{ fehler }}</span>
  </div>

  <!-- LADEZUSTAND -->
  <mat-progress-bar mode="indeterminate" *ngIf="laedt"></mat-progress-bar>

  <!-- KENNZAHLEN -->
  <mat-card class="sps-card" *ngIf="!fehler">
    <mat-card-content>
      <div class="kennzahlen">
        <div>
          <span>Listen</span>
          <strong>{{ listen.length }}</strong>
        </div>
        <div>
          <span>SPS-Zuordnungslisten</span>
          <strong>{{ zuordnungslisten.length }}</strong>
        </div>
        <div>
          <span>PLC-Tag-Listen</span>
          <strong>{{ plcTagListen.length }}</strong>
        </div>
        <div>
          <span>Importierte Einträge</span>
          <strong>{{ eintraegeGesamt }}</strong>
        </div>
        <div matTooltip="Eindeutige SPS-Signale – gleiche Signale aus mehreren Listen zählen einmal">
          <span>Gemeinsame Signale</span>
          <strong>{{ fortschritt.gesamt }}</strong>
        </div>
      </div>


    </mat-card-content>
  </mat-card>

  <!-- LISTEN -->
  <mat-card class="sps-card" *ngIf="!fehler">
    <mat-card-content>

      <!-- LEERER ZUSTAND -->
      <div class="leer" *ngIf="!laedt && listen.length === 0">
        <mat-icon>developer_board</mat-icon>
        <h3>Noch keine SPS-Listen importiert</h3>
        <p>
          Importieren Sie eine SPS-Zuordnungsliste oder eine PLC-Tag-Liste – beide Listentypen
          können unabhängig voneinander importiert werden.
        </p>
        <button mat-raised-button color="primary" type="button" *ngIf="canEdit" (click)="zumImport()">
          <mat-icon>upload_file</mat-icon>
          Listen importieren
        </button>
      </div>

      <!-- GRUPPEN -->
      <div class="gruppen" *ngIf="listen.length > 0">

        <ng-container *ngTemplateOutlet="gruppe; context: {
          titel: 'SPS-Zuordnungslisten',
          untertitel: 'SPS-Module, Kanäle und Anschlüsse',
          icon: 'developer_board',
          listen: zuordnungslisten,
          leer: 'Keine SPS-Zuordnungsliste importiert.'
        }"></ng-container>

        <ng-container *ngTemplateOutlet="gruppe; context: {
          titel: 'PLC-Tag-Listen',
          untertitel: 'SPS-Signale, Ein- und Ausgänge',
          icon: 'swap_vert',
          listen: plcTagListen,
          leer: 'Keine PLC-Tag-Liste importiert.'
        }"></ng-container>

      </div>

    </mat-card-content>
  </mat-card>

</section>


<!-- EINE GRUPPE (Listentyp) -->
<ng-template #gruppe let-titel="titel" let-untertitel="untertitel" let-icon="icon" let-gruppenListen="listen" let-leer="leer">
  <section class="gruppe">

    <div class="gruppe-kopf">
      <mat-icon>{{ icon }}</mat-icon>
      <div>
        <h3>{{ titel }}</h3>
        <p>{{ untertitel }}</p>
      </div>
      <span class="gruppe-anzahl">{{ gruppenListen.length }}</span>
    </div>

    <p class="gruppe-leer" *ngIf="gruppenListen.length === 0">{{ leer }}</p>

    <div class="zeilen">
      <div class="zeile" *ngFor="let liste of gruppenListen; trackBy: trackByListe" [class.zeile-loeschend]="wirdGeloescht(liste)">

        <div class="zeile-haupt" role="button" tabindex="0" (click)="oeffnen(liste)" (keydown.enter)="oeffnen(liste)"
          [matTooltip]="typInfo(liste).titel + ' öffnen'">

          <mat-icon class="zeile-icon">{{ typInfo(liste).icon }}</mat-icon>

          <div class="zeile-text">
            <span class="zeile-name">{{ liste.name }}</span>
            <span class="zeile-meta">
              <span class="zeile-typ">{{ typInfo(liste).titel }}</span>
              <span>· {{ liste.dateiName }}</span>
              <span *ngIf="liste.tabellenblatt">· Blatt „{{ liste.tabellenblatt }}“</span>
            </span>
            <span class="zeile-meta">
              <span>{{ liste.importiertAmUtc | date:'dd.MM.yyyy HH:mm' }}</span>
              <span *ngIf="liste.importiertVon">· {{ liste.importiertVon }}</span>
              <span *ngIf="liste.aktualisiertAmUtc" matTooltip="Zuletzt mit einer neueren Excel-Version aktualisiert">
                · aktualisiert {{ liste.aktualisiertAmUtc | date:'dd.MM.yyyy HH:mm' }}
              </span>
              <span *ngIf="liste.anlagenteilSpalte">· Anlagenteile aus „{{ liste.anlagenteilSpalte }}“</span>
            </span>
          </div>

          <div class="zeile-zahlen">
            <span class="zahl-chip">{{ liste.eintraegeAnzahl }} Einträge</span>
            <span class="zahl-chip zahl-chip-warn" *ngIf="liste.signaleUngeklaert > 0"
              matTooltip="Zeilen, deren Zuordnung zu einem Signal noch zu klären ist">
              {{ liste.signaleUngeklaert }} ungeklärt
            </span>
          </div>

          <div class="zeile-aktionen">
            <button mat-icon-button type="button" class="listen-menue-trigger"
              *ngIf="canEdit" [matMenuTriggerFor]="listenAktionen" [disabled]="wirdGeloescht(liste)"
              (click)="$event.stopPropagation()" (keydown.enter)="$event.stopPropagation()"
              aria-label="Aktionen für diese Liste" matTooltip="Listenaktionen">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #listenAktionen="matMenu" xPosition="before" class="listen-aktionen-menue">
              <button mat-menu-item type="button" (click)="oeffnen(liste); $event.stopPropagation()">
                <mat-icon>open_in_new</mat-icon><span>Öffnen</span>
              </button>
              <button mat-menu-item type="button" (click)="aktualisierenStarten(liste, $event)">
                <mat-icon>sync</mat-icon><span>Liste aktualisieren</span>
              </button>
              <button mat-menu-item type="button" class="listen-menue-loeschen"
                (click)="loeschenStarten(liste, $event)">
                <mat-icon color="warn">delete_outline</mat-icon><span>Löschen</span>
              </button>
            </mat-menu>
            <mat-spinner diameter="20" *ngIf="wirdGeloescht(liste)" aria-label="Liste wird gelöscht"></mat-spinner>
            <mat-icon class="zeile-chevron" *ngIf="!canEdit">chevron_right</mat-icon>
          </div>

        </div>
      </div>
    </div>

  </section>
</ng-template>
